export default "__VITE_ASSET__BsHYmg9t__"